import { tawlaAuthReturnPath, tawlaRegistrationAgentRid } from "./TawlaRoomInvite";
import { holdemAuthReturnPath, holdemRegistrationAgentRid } from "./HoldemRoomInvite";

export function roomInviteAuthReturnPath(backTo) {
  return tawlaAuthReturnPath(backTo) || holdemAuthReturnPath(backTo);
}

export function roomInviteRegistrationAgentRid(backTo, storedAgentRid) {
  return holdemRegistrationAgentRid(backTo, tawlaRegistrationAgentRid(backTo, storedAgentRid));
}
